import React from "react";
import { formatDate, formatDateWithTime } from "Common/HelperClass";
import TableSkeletonElement from "../../GMS/Products/components/TableSkeletonElement";
import Paginator from "../Paginator";
import CopyIcon from "../components/CopyIcon";
import { CopyIcon as Copy } from "assests/GmsIcons";
import { DeleteIcon } from "assests/GmsIcons";
import PropTypes from "prop-types";
import ToggleButton from "../components/Inputs/ToggleButton";
const Table = ({ headers, data, handleColumnDrag, recordPerPage, setRecordPerPage, handlePageChange, handleSortByColumn, sort, loading, handleViewLog, NoDataComponent, handleDelete, page, handleCopy }) => {

  const multiplyIfSeconds = (number) => {
    const numberString = number.toString();
    const indexOfDecimal = numberString.indexOf(".");
    const digitsBeforeDecimal =
      indexOfDecimal === -1 ? numberString.length : indexOfDecimal;
    if (digitsBeforeDecimal === 13) {
      return number;
    } else {
      return number * 1000;
    }
  }

  if (loading) {
    return (
      <div className="">
        <TableSkeletonElement />
      </div>
    );
  }

  return (
    <div className="tw-overflow-hidden tw -mt-2" style={{ maxHeight: "100vh", }}>
      <div className="tw-container tw-overflow-hidden ">
        <div className=" tw-row-auto tw-overflow-scroll">
          {data && data.length > 0 ? (
            <div className="tw-p-0 tw-rounded-sm tw-border">
              <div className="tw-p-0 tw-max-h-[75vh]">
                <table id="partyTable" className="tw-bg-[#DFE1E6] tw-table tw-border tw-w-[100%] tw-m-0">
                  <thead className=" tw-sticky tw-top-0 tw-bg-[#DFE1E6] tw-uppercase">
                    <tr>
                      {headers.map(({ label, ...rest }, index) => (
                        <th key={`${index}_${label}`} className="table-header-style" scope="col"
                          draggable={true}
                          onDragStart={(event) => { event.dataTransfer.setData("text/plain", index); }}
                          onDragOver={(event) => { event.preventDefault(); }}
                          onDrop={(event) => {
                            event.preventDefault();
                            const sourceIndex = Number(event.dataTransfer.getData("text/plain"));
                            const targetIndex = index;
                            handleColumnDrag(event, sourceIndex, targetIndex);
                          }} >
                          <div className="tw-flex tw-align-middle" onClick={() => { rest.options?.sort && handleSortByColumn(rest.map); }}>
                            {["edit", "delete", "copy"].includes(label?.toLowerCase()) ? ("") : (<label className="tw-text-[#5c5f62]">{label}</label>)}
                            &nbsp;
                            <span>
                              {rest.options?.sort && (sort.column === rest.map ? (<i className={`fas fa-sort-${sort.direction === "asc" ? "up" : "down"}`} />) : (<i className={"fas fa-sort"} />))}
                            </span>
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="tw-bg-white tw-divide-y tw-divide-[#F4F5F7]">
                    {
                      // for pagination
                      data?.slice(page * recordPerPage - recordPerPage, page * recordPerPage)
                        .map((row, index) => (
                          <tr key={index} className="tw-border tw-h-[42px]">
                            {headers.map(({ label, options, map }) => {
                              if (["Started At", "Created At"].includes(label)) {
                                return (
                                  <td className={`table-item-style ${index % 2 === 0 ? 'tw-bg-[#F4F5F7]' : 'tw-bg-white'}`} key={`${index}_${label}`}>
                                    {row[map] ? formatDate(multiplyIfSeconds(row[map])) : ""}
                                  </td>
                                );
                              } else if (["Started Date", "End Date", "Created", "Created on", "CREATED ON"].includes(label)
                              ) {
                                return (
                                  <td className={`table-item-style tw-cursor-pointer ${index % 2 === 0 ? 'tw-bg-[#F4F5F7]' : 'tw-bg-white'}`} key={`${index}_${label}`}>
                                    {row[map] ? formatDateWithTime(multiplyIfSeconds(row[map])) : ""}
                                  </td>
                                );
                              } else if (label === "View Logs") {
                                return (
                                  <td className={`table-item-style tw-cursor-pointer ${index % 2 === 0 ? 'tw-bg-[#F4F5F7]' : 'tw-bg-white'}`} key={`${index}_${label}`} >
                                    <button type="button" className="tw-p-0 tw-bg-transparent tw-border-0 tw-text-primary" onClick={() => handleViewLog(index)} >View Logs</button>
                                  </td>
                                );
                              } else if (label === "Status") {
                                return (
                                  <td className={`table-item-style tw-cursor-pointer ${index % 2 === 0 ? 'tw-bg-[#F4F5F7]' : 'tw-bg-white'}`} key={`${index}_${label}`}>
                                    <span className="tw-rounded-lg" data-value={map ? row[map] : ""} >
                                      {map ? row[map] : ""}
                                    </span>
                                  </td>
                                );
                              } else if (label.toLowerCase() === "delete") {
                                return (
                                  <td className={`table-item-style tw-text-primary  tw-cursor-pointer ${index % 2 === 0 ? 'tw-bg-[#F4F5F7]' : 'tw-bg-white'}`} key={`${index}_${label}`} >
                                    <button className=" tw-cursor-pointer tw-flex tw-align-middle tw-text-danger"
                                      onClick={(e) => { options?.index ? handleDelete(index) : handleDelete(e, row[options.apiKey], options.callback); }}>
                                      <DeleteIcon />
                                    </button>
                                  </td>
                                );
                              }
                              else if (label.toLowerCase() === "copy") {
                                return (
                                  <td className={`table-item-style tw-text-primary  tw-cursor-pointer ${index % 2 === 0 ? 'tw-bg-[#F4F5F7]' : 'tw-bg-white'}`} key={`${index}_${label}`} >
                                    <button className=" tw-cursor-pointer tw-flex tw-align-middle tw-text-danger"
                                      onClick={() => { handleCopy(index) }}>
                                      <Copy />
                                    </button>
                                  </td>
                                );
                              }
                              else if (label === "Edit") {
                                return (
                                  <td
                                    className={`table-item-style tw-text-primary tw-cursor-pointer ${index % 2 === 0 ? 'tw-bg-[#F4F5F7]' : 'tw-bg-white'}`}
                                    key={`${index}_${label}`}
                                  >
                                    <button
                                      className=" tw-cursor-pointer tw-flex tw-align-middle tw-text-primary"
                                      onClick={(e) => handleViewLog(index)}
                                    >
                                      {/* <i className={"fas fa-trash-alt"} /> */}
                                      Edit
                                    </button>
                                  </td>
                                );
                              } else if (label === "Enable/Disable") {
                                return (
                                  <td className={`table-item-style tw-cursor-pointer ${index % 2 === 0 ? 'tw-bg-[#F4F5F7]' : 'tw-bg-white'}`} key={`${index}_${label}`}>
                                    <ToggleButton value={row["is_disabled"]} name={`toggle-${index}`} onChange={(e) => { options?.handleSwitch(e, row); }} />
                                  </td>
                                );
                              } else {
                                return (
                                  <td className={`table-item-style tw-cursor-pointer ${index % 2 === 0 ? 'tw-bg-[#F4F5F7]' : 'tw-bg-white'}`} key={`${index}_${label}`} >
                                    <div className="tw-flex tw-align-middle">
                                      {
                                        // check if clipboard is active for this row
                                        options?.copy ? (<> <CopyIcon text={row[map]} /> </>) : null
                                      }
                                      {map ? (
                                        // truncate if necessary
                                        !options?.truncate ? (
                                          options?.isLink ? (
                                            <button type="button" className="tw-p-0 tw-bg-transparent tw-border-0 tw-text-primary" onClick={() => handleViewLog(index)} >{row[map]}</button>
                                          ) : (row[map])
                                        ) : (
                                          <span data-bs-toggle="tooltip" title={row[map]}>
                                            {row[map]?.slice(0, options?.truncate)}...
                                          </span>
                                        )
                                      ) : ("")}
                                    </div>
                                  </td>
                                );
                              }
                            })}
                          </tr>
                        ))
                    }
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <NoDataComponent />
          )}
        </div>
        <div className="tw-mb-2">
          {data && data.length > 0 ? (
            <div className="tw-flex tw-justify-end tw-align-bottom tw-items-center tw-space-x-3">
              <span className="tw-mt-4">Show</span>
              <select className="tw-h-min tw-w-[70px] tw-border tw-p-1 tw-rounded-sm tw-mt-4" aria-label="Default select example" defaultValue={recordPerPage} onChange={(e) => setRecordPerPage(e.target.value)}>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>All</option>
              </select>
              <Paginator
                presentPage={page}
                recordPerPage={recordPerPage}
                totalRecords={data?.length}
                data={data}
                onPageChange={handlePageChange}
                simple={true}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};


Table.propTypes = {
  data: PropTypes?.array?.isRequired
}

export default Table;